<template>
  <section class="article-body" v-html="body" />
</template>

<script>
export default {
  props: {
    body: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_article-body.scss';
</style>
